import React from 'react';
import { GridPattern } from '../common/GridPattern';
import { Cartesian3DAxes } from '../common/CartesianAxes';
import { DraggablePoint } from '../common/DraggablePoint';

export const SquarePyramidComponent = ({ params, showCoords, onPointDrag, svgRef, viewportWidth = 400, viewportHeight = 300, viewportScale = 1 }) => {
  const { baseSize = 120, height = 100, centerX = 200, centerY = 150, baseFill = "lightgray", stroke = "black", strokeWidth = 2 } = params;
  
  const halfBase = baseSize / 2;
  const apexX = centerX;
  const apexY = centerY - height;
  
  const frontLeft = [centerX - halfBase, centerY + halfBase / 2];
  const frontRight = [centerX + halfBase, centerY + halfBase / 2];
  const backLeft = [centerX - halfBase / 3, centerY - halfBase / 3];
  const backRight = [centerX + halfBase / 3, centerY - halfBase / 3];
  
  const scaledWidth = viewportWidth * viewportScale;
  const scaledHeight = viewportHeight * viewportScale;
  const viewBox = `0 0 ${scaledWidth} ${scaledHeight}`;
  const displayHeight = Math.max(200, Math.min(800, viewportHeight * viewportScale));
  
  return (
    <svg ref={svgRef} viewBox={viewBox} className="w-full border border-gray-300" style={{ height: `${displayHeight}px` }}>
      <GridPattern viewportWidth={viewportWidth} viewportHeight={viewportHeight} viewportScale={viewportScale} />
      
      <polygon
        points={`${frontLeft[0]},${frontLeft[1]} ${frontRight[0]},${frontRight[1]} ${backRight[0]},${backRight[1]} ${backLeft[0]},${backLeft[1]}`}
        fill={baseFill}
        stroke={stroke}
        strokeWidth={strokeWidth}
      />
      
      <line x1={frontLeft[0]} y1={frontLeft[1]} x2={apexX} y2={apexY} stroke={stroke} strokeWidth={strokeWidth}/>
      <line x1={frontRight[0]} y1={frontRight[1]} x2={apexX} y2={apexY} stroke={stroke} strokeWidth={strokeWidth}/>
      <line x1={backLeft[0]} y1={backLeft[1]} x2={apexX} y2={apexY} stroke={stroke} strokeWidth={strokeWidth} strokeDasharray="5,5"/>
      <line x1={backRight[0]} y1={backRight[1]} x2={apexX} y2={apexY} stroke={stroke} strokeWidth={strokeWidth} strokeDasharray="5,5"/>
      
      {showCoords && (
        <>
          <DraggablePoint 
            cx={apexX} cy={apexY} 
            label="Apex" coords={`(${apexX},${Math.round(apexY)})`}
            onDrag={(x, y) => {
              const newHeight = Math.max(50, Math.min(150, centerY - y));
              onPointDrag('height', newHeight);
            }}
            svgRef={svgRef}
          />
          <DraggablePoint 
            cx={centerX} cy={centerY} 
            label="Center" coords={`(${centerX},${centerY})`}
            onDrag={(x, y) => onPointDrag('centerX', x, 'centerY', y)}
            svgRef={svgRef}
          />
        </>
      )}
      
      <Cartesian3DAxes viewportWidth={viewportWidth} viewportHeight={viewportHeight} viewportScale={viewportScale} />
    </svg>
  );
};

